import type { CorridorDefinition } from "@/types/corridor";
import { resolveCorridorSlug } from "./corridorSeoSlugs";
import { hyderabadVijayawadaCorridor } from "./hyderabad-vijayawada";
import { hyderabadGunturCorridor } from "./hyderabad-guntur";
import { additionalPopularCorridors } from "./additionalPopularCorridors";
import { CORRIDOR_ROUTE_GUIDES } from "./routeGuides";

function attachRouteGuides(
  registry: Record<string, CorridorDefinition>,
): Record<string, CorridorDefinition> {
  return Object.fromEntries(
    Object.entries(registry).map(([slug, corridor]) => {
      const guide = CORRIDOR_ROUTE_GUIDES[slug];
      return [slug, guide ? { ...corridor, routeGuide: guide } : corridor];
    }),
  );
}

/** Primary corridor when visiting `/` — swap when you add more regions. */
export const DEFAULT_CORRIDOR_SLUG = "hyderabad-vijayawada";

/** Pre-footer “Popular routes” grid order (matches marketing layout). */
export const POPULAR_ROUTE_SLUGS: string[] = [
  hyderabadVijayawadaCorridor.slug,
  hyderabadGunturCorridor.slug,
  ...additionalPopularCorridors.map((c) => c.slug),
];

const baseCorridorRegistry: Record<string, CorridorDefinition> = {
  [hyderabadVijayawadaCorridor.slug]: hyderabadVijayawadaCorridor,
  [hyderabadGunturCorridor.slug]: hyderabadGunturCorridor,
  ...Object.fromEntries(additionalPopularCorridors.map((c) => [c.slug, c])),
};

export const corridorRegistry: Record<string, CorridorDefinition> =
  attachRouteGuides(baseCorridorRegistry);

export function getCorridorBySlug(slug: string | undefined): CorridorDefinition | undefined {
  if (!slug) return undefined;
  return corridorRegistry[resolveCorridorSlug(slug)];
}

export function listCorridorSlugs(): string[] {
  return Object.keys(corridorRegistry);
}
